import routes from '../../navigation/routes'
import TabbedPage from '../../navigation/Tabs/TabbedPage'
import ArtistQuickView from './ArtistQuickView'
import { GET_ARTIST_DETAILS } from '../Queries'
import { useParams } from 'react-router-dom'
import { DYNAMIC_ARTISTS_SEARCH } from '../../Search/Queries'

export default function Artist(props) {
	const params = useParams()

	return TabbedPage({
		...props,
		routes: routes.artistPages.pages,
		Quickview: ArtistQuickView,
		query: GET_ARTIST_DETAILS,
		searchGlobalQuery: DYNAMIC_ARTISTS_SEARCH,
		options: routes.artistPages.options,
		params,
	})
}
